import {
  openPopupPromise,
  PopupDialogOrigin,
} from 'src/lib/popups/popupOpenClose';
import { user } from 'src/StateObserver';
import features from 'src/replicant/ruleset/features';
import { getTutorialController } from '../tutorial/TutorialController';

export async function openProfile(origin: PopupDialogOrigin | undefined) {
  // Feature disabled, bail.
  if (!features(user()).ingameProfile) {
    return;
  }

  // Await for tutorial to be completed.
  await getTutorialController().handleEvent('profilePopupOpened');

  // No public profile yet, should create one.
  const { publicProfile } = user();

  if (!publicProfile) {
    // NB: with hideCloseButton this popup never has a cancel option
    // If that changes then it needs to be handled
    await openPopupPromise('popupEditProfileV2', {
      hideCloseButton: true,
      origin,
    });
  }

  await openPopupPromise('popupProfileV2', {
    origin,
  });
}
